module.exports = __webpack_public_path__ + "img/ts19.7a55a278.png";